// Default value for now, will be replaced with actual integration logic in separate PRs
function useIntegration() {
  return {
    integrated: true,
    integratedBy: {
      name: 'Robert Downey Jr.',
      image_url: '',
    },
  }
}

export default useIntegration
